import fetchApi from "../../services/fetch";
import { hnAPI } from "../../constants/api";
import { track, generateMessageDisplayedSegment, generateServerResponseError } from 'utils/segmenTracker';
import { ACTIVATION, SALES_REPORT_DISPLAYED, MESSAGE_DISPLAYED, SERVER_RESPONSE_FAILED } from 'constants/segmentEvents'
import { get } from "lodash";

const initialState = {
  salesData: []

};

export const sales = {
  state: { ...initialState },
  reducers: {
    updateSalesData(state, payload) {
      return {
        ...state,
        salesData: [...state.salesData, ...payload],
      };
    },
    clearSales() {
      return {
        ...initialState,
      };
    },
  },

  effects: (dispatch) => {
    return {
      async getSalesReport() {
        const { pos_dmsid } = localStorage.getItem('auth') ? JSON.parse(atob(localStorage.getItem('auth'))) : {};
        this.clearSales();
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: "get",
          url: hnAPI.salesReport,
          params: {'salesInfo.salespersonId': pos_dmsid },
        })
          .then((response) => {
            const ordersList = get(response, 'data.orderList') || get(response, 'data.ordersList') || [];
            this.updateSalesData(ordersList);
            dispatch.apiStatus.setProcessing(false);
            track(SALES_REPORT_DISPLAYED, { journey: ACTIVATION })
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {...generateServerResponseError(error, ACTIVATION, 'Sales Report', hnAPI.salesReport, 'Sales Report API')})
            track(MESSAGE_DISPLAYED, {...generateMessageDisplayedSegment(error, ACTIVATION, 'Sales Report API')})
          });
      },
      async cancelOrder({callback, orderData}) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: "PATCH",
          url: `${hnAPI.activation}/${orderData.orderId}`,
          data: { reasonId  :  orderData.reasonId},
        })
          .then(response => {
            dispatch.apiStatus.setProcessing(false);
            callback(response.data)
          })
          .catch(error => {
            dispatch.apiStatus.setRequestFailed({ ...error });
          });
      },
    };
  },
};
